import React from 'react';

type Props = {
    /**
     * 수강권 상세처럼 **원매출 환불이 열려 있는 화면**인지.
     *
     * 탈퇴 가드는 신규 원매출 환불 라우트 한 곳에서만 풀렸다(G4). 회원 프로필처럼 그 예외가
     * 없는 화면에서 "환불은 됩니다"라고 하면 없는 버튼을 찾게 만든다.
     */
    canRefundOriginalSales?: boolean;
};

const WithdrawnMemberReadOnlyNotice = ({ canRefundOriginalSales = false }: Props) => (
    <div
        role="status"
        style={{
            width: '100%',
            padding: '14px 18px',
            borderRadius: 12,
            border: '1px solid #FDE68A',
            backgroundColor: '#FFFBEB',
            color: '#92400E',
            fontSize: 14,
            fontWeight: 600,
            lineHeight: 1.5,
        }}
    >
        앱을 탈퇴한 회원입니다. 탈퇴 당시 기록을 보존하기 위해 조회만 가능하며 프로필, 담당 강사,
        수강권, 일정, 이용권 및 결제 정보는 변경할 수 없습니다.
        {canRefundOriginalSales && (
            // U7 — 환불은 되지만 되돌릴 수 없다. 실행 전에 말해야 의미가 있다.
            // 문구는 모바일 관리자 웹(M5)과 통일한다.
            <div style={{ marginTop: 8, fontWeight: 500 }}>
                탈퇴 회원은 원매출 환불만 가능합니다. 환불 내역은 이후 수정·삭제할 수 없으니 금액과
                회차를 확인해 주세요.
            </div>
        )}
    </div>
);

export default WithdrawnMemberReadOnlyNotice;
